<template>
  <div
    class="h-full flex flex-col justify-between relative w-full max-w-screen-app-max m-auto"
    :class="{ 'safe-top': Capacitor.isNativePlatform() }"
  >
    <div class="flex-grow">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { Capacitor } from '@capacitor/core'
</script>
